<script type="text/javascript">
	
	import VueSelect from './select/components/Select.vue'
	import mixins from './select/mixins/index'

	export default VueSelect
	export { VueSelect, mixins }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/VueSelect.vue